export enum TimestampUnit {
  MILLISECONDS = 'x',
  SECONDS = 'X',
}
